import styled, { css, keyframes } from 'styled-components';
import { device } from '../breakpoints';
import { playGrey10 } from '../design-tokens';

export const imgPadding16By9 = '28.125% 0';
export const imgPaddingCinema = '21.667% 0';
export const imgPaddingSquare = '50% 0';
export const imgPadding2By3 = '75% 0';
export const imgPaddingImax = '19.5312% 0';

const imagePlaceholder = keyframes`
    0% {
        transform: scale(0.96);
    }

    50% {
        transform: scale(1);
    }

    100% {
        transform: scale(0.96);
    }
`;

const playFadeIn = keyframes`
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
`;

const playFadeInLowOpacity = keyframes`
    0% {
        opacity: 0;
    }

    100% {
        opacity: 0.3;
    }
`;

const getPadding = (ratio) => {
    switch (ratio) {
        case '16-9':
            return css`
                padding: ${imgPadding16By9};
            `;
        case '2-3':
            return css`
                padding: ${imgPadding2By3};
            `;
        case 'imax':
            return css`
                padding: ${imgPadding16By9};

                @media ${device.GteSmall} {
                    padding: ${imgPaddingImax};
                }
            `;
        case 'cinema':
            return css`
                padding: ${imgPaddingCinema};
            `;
        case 'square':
            return css`
                padding: ${imgPaddingSquare};
            `;
        default:
            return css`
                padding: ${imgPadding16By9};
            `;
    }
};

export const ImageContainer = styled.div`
    position: relative;
    background: ${playGrey10};
    ${(props) => getPadding(props.imageRatio)}
    ${(props) =>
        props.opacity &&
        css`
            background: transparent;
            transition: all 140ms ease-in-out;
        `}
`;

export const Image = styled.img`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    display: block;

    ${(props) =>
        props.opacity &&
        css`
            opacity: ${props.opacity};
            transition: opacity 140ms ease-in-out;
        `}

    ${(props) =>
        props.loaded &&
        css`
            animation: ${playFadeIn} 350ms ease-out;
        `}

    .android {
        ${(props) =>
            props.loaded &&
            css`
                animation: none;
            `}
    }

    ${(props) =>
        props.blurred &&
        props.loaded &&
        css`
            .no-sweden & {
                animation: ${playFadeInLowOpacity} 350ms ease-out;
            }
        `}

    ${(props) =>
        props.blurred &&
        css`
            .no-sweden & {
                opacity: 0.3;
                filter: blur(2px);
            }
        `}

    ${(props) =>
        props.showPlaceholderImage &&
        css`
            background-color: rgba(255, 255, 255, 0.02);
            animation: ${imagePlaceholder} 1000ms infinite;
        `}
`;
